<template>
    <el-drawer
            :title="$t('savedSearches')"
            :append-to-body="true"
            :visible.sync="visible"
            size="750px"
            custom-class="GetSavedQuery"
            direction="ltr">
        <div class="savedQueries" v-loading="loading">
            <div class="queryItem" v-for="q in queries" :key="q.id"
                 v-show="!selectedDocType || selectedDocType === q.docType">
                <div>
                    <div class="title" :class="{linkLike: isMultiple}" @click="handleCheck(q)">{{q.name}}</div>
                    <div class="attr">
                        <div class="label">{{$t('compare.docType')}}</div>
                        <div class="val">{{(q.filter.types || [])[0]}}</div>
                    </div>
                    <div class="attr">
                        <div class="label">{{$t('compare.query')}}</div>
                        <table class="structuredQueryTab"
                               v-if="((q.filter.structuredQuery || {}).rows || []).length">
                            <tr v-for="(row, ind) in q.filter.structuredQuery.rows" :key="ind">
                                <td>
                                    <div>{{row.operator}}</div>
                                </td>
                                <td>
                                    <div><span v-for="(fld, fkey) in row.fields" :key="fkey">
                                            {{fld}}
                                        </span></div>
                                </td>
                                <td>
                                    <div>{{row.query}}</div>
                                </td>
                            </tr>
                        </table>

                        <div class="val" v-else v-html="formatQueryNotions(q.filter.query)"></div>
                    </div>
                </div>
                <div>
                    <i class="pointer" v-if="isMultiple"
                       :class="isSelected(q) ? 'fas fa-check-square iq-text-primary'
                       : selectedQueries.length > maxQueries && !isSelected(q) ? 'fas fa-square iq-text-placeholder not-allowed'
                       : 'far fa-square iq-text-secondary'"
                       @click="handleCheck(q)"></i>
                    <el-button type="primary" @click="handleSelectQuery(q)" v-else plain>{{$t('apply')}}</el-button>
                </div>
            </div>
        </div>
        <div class="footer" v-if="isMultiple">
            <el-button class="px-4" type="primary" @click="handleSelectQuery()">{{$t('apply')}}</el-button>
        </div>
    </el-drawer>
</template>

<script>
    import {mapState} from "vuex";
    import mixins from "../common/mixin";

    export default {
        name: "GetSavedQuery",
        mixins: [mixins],
        props: {},
        computed: {
            ...mapState({
                userInfo: state => state.userInfo,
            }),
            isMultiple() {
                return this.mode === 'multiple'
            },
            selectedQueries() {
                return this.selected.map(it => {
                    return this.queries.find(q => q.id === it)
                }).map(q => {
                    q.filter.name = q.name;
                    q.filter.types = q.filter.types ?? [q.docType];
                    return q
                })
            },
            selectedDocType() {
                return (this.selectedQueries[0]?.filter?.types || [])[0]
            },
        },
        watch: {
            visible(state) {
                if (state) {
                    this.getQueries();
                }
            }
        },
        data() {
            return {
                visible: false,
                loading: true,
                queries: [],
                mode: 'single',
                maxQueries: 2,
                selected: [],
            }
        },
        methods: {
            getQueries() {
                let _query = {
                    userIds: [this.userInfo.id],
                    fullness: "FULL",
                    offset: 0,
                    count: 100,
                    order: [{field: 'dateCreate', type: 'DESC'}]
                };
                this.loading = true;
                this.$services.savedQueries.list(_query).then(resp => {
                    this.queries = (resp.data.list || []).filter(it => (it.filter.query || it.filter.structuredQuery))
                        .map(it => {
                            it.selected = false;
                            it.docType = (it.filter.types || [])[0] || ''
                            return it
                        })
                    this.loading = false;

                })
            },
            handleSelectQuery(query = null) {
                if(query){
                    query.filter.name = query.name;
                }
                let queries = query ? [query.filter] : _.map(this.selectedQueries, 'filter'),
                    toDel = [
                        'subfilters',
                        "explain",
                        "profile",
                        "suggestQuery",
                        "facets",
                    ];
                queries.forEach(q => {
                    toDel.forEach(attr => {
                        delete q[attr]
                    })
                    q.count = 0;
                    q.offset = 0;
                });
                // console.log('QF -- ', queries)
                if (queries.length) {
                    this.$emit('selectedQueries', {mode: this.mode, queries: queries});
                }
                this.visible = false;

            },
            handleCheck(q) {
                if (this.selectedQueries.length > this.maxQueries && !this.isSelected(q)) {
                    this.$message.error(this.$t('compare.tooManyChecks'));
                } else {
                    if (this.selected.includes(q.id)) {
                        this.selected = this.selected.filter(it => {
                            return it !== q.id
                        })
                    } else {
                        this.selected.push(q.id)
                    }
                }
            },
            isSelected(q){
                return this.selected.includes(q.id)
            },
            reset(){
                this.queries = [];
                this.selected = [];
            }

        },
    }
</script>

<style lang="scss">
    .GetSavedQuery {
        .el-drawer__header {
            padding: 10px 15px;
            background: $iq-color-primary;
            color: #fff;
            font-weight: 500;
            font-size: 18px;
            margin-bottom: 0;
        }

        .el-drawer__body {
            padding: 10px 15px;
            //overflow: hidden auto;
        }

        .savedQueries {
            display: flex;
            flex-direction: column;
            gap: 15px;
            height: calc(100vh - 100px);
            overflow: hidden auto;
            padding-right: 15px;

            .queryItem {
                border-bottom: 1px solid $iq-border-color-base;
                padding-bottom: 15px;
                display: flex;
                align-items: flex-start;
                gap: 30px;
                justify-content: space-between;

                .title {
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 5px;
                }

                .attr {
                    display: flex;
                    gap: 15px;
                    align-items: flex-start;
                    font-size: 16px;

                    & + .attr {
                        margin-top: 7px;
                    }
                }

                .label {
                    padding-top: 3px;
                }

                .val {
                    //background: #D6E3FF;
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-size: 14px;
                    border: 1px solid $iq-border-color-light;
                }
            }
        }

        .footer {
            text-align: right;
            padding: 5px 10px 0 10px;;
        }

        .structuredQueryTab {
            td {
                padding: 1px 2px;
                font-size: 13px;
            }
        }
    }
</style>